export default {
    encoding: [
        {
            name: 'value',
            type: 'number',
            desc: 'Specify the dataSource applied to the value of filler gauge.',
            defaultValue: 'primary[0][-1]',
            isRequired: 'true',
        },
        {
            name: 'gaugeColor',
            type: 'string',
            desc: 'Specify the dataSource applied to the gauge color of the filler gauge.',
            isRequired: 'false',
        },
    ],
    events: [],
};
